import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=7718399f&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=7718399f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7718399f",
  null
  
)

export default component.exports